// 내장 라이브러리
import { computed, ref } from 'vue';

import { COMPANY_TITLE } from '@/constants/title';
import { usePopupStore } from '@/stores/popup';

export const useTimer = (time: number) => {
	const popupStore = usePopupStore();
	const timeLeft = ref(time); // 문자인증 제한시간

	let itId: NodeJS.Timeout;
	const startTimer = () => {
		// 문자인증 제한시간
		endTimer();
		itId = setInterval(() => {
			timeLeft.value--;
			if (timeLeft.value === 0) {
				endTimer();
				const timeAlert = setTimeout(() => {
					popupStore.openPopup({
						content: COMPANY_TITLE,
						subtext: '유효 시간이 만료되었습니다.\n다시 시도해 주세요.',
					});
					clearTimeout(timeAlert);
				}, 100);
			}
		}, 1000);
	};
	const endTimer = () => {
		clearInterval(itId);
	};

	const restartTimer = () => {
		endTimer();
		timeLeft.value = time;
		startTimer();
	};

	const minutesLeft = computed(() => {
		return Math.floor(timeLeft.value / 60)
			.toString()
			.padStart(1, '0');
	});

	const secondLeft = computed(() => {
		return Math.floor(timeLeft.value % 60)
			.toString()
			.padStart(2, '0');
	});

	return {
		minutesLeft,
		secondLeft,
		startTimer,
		endTimer,
		restartTimer,
	};
};
